async function r(o){return"clipboard"in navigator?await navigator.clipboard.writeText(o):document.execCommand("copy",!0,o)}export{r as copyTextToClipboard};
//# sourceMappingURL=clipboard.helpers.js.map
